module.exports = __webpack_public_path__ + "media/images/weather/100_night-0e8723ab654cf95b64e2c6ba18285665.png";